// Free-webmail / disposable domains rejected at signup.
//
// Mirrors the seed in `backend/supabase/migrations/0005_organizations.sql`.
// The server-side BEFORE INSERT trigger on auth.users is the authority
// (errcode P0004, message `email_domain_not_allowed: <domain> ...`); this
// client-side list exists so the user sees the rejection before the round
// trip to Supabase Auth. Drift is harmless — the server still blocks.
//
// Anti-fraud rationale: auto-join by domain (migration 0005 §6) means a
// single shared "gmail.com" org would collect every personal-Gmail signup
// into one bucket — an admin/member chaos pile. Public domains stay out
// entirely; users must sign up with a company email.

export const BLOCKED_EMAIL_DOMAINS: ReadonlySet<string> = new Set([
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'ymail.com',
  'rocketmail.com',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'msn.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'aol.com',
  'protonmail.com',
  'proton.me',
  'pm.me',
  'gmx.com',
  'gmx.net',
  'gmx.de',
  'mail.com',
  'yandex.com',
  'yandex.ru',
  'zoho.com',
  'fastmail.com',
  'fastmail.fm',
  'duck.com',
  'hey.com',
  'tutanota.com',
  'tuta.io',
  'inbox.com',
]);

export function emailDomain(email: string): string {
  const at = email.lastIndexOf('@');
  if (at < 0) return '';
  return email.slice(at + 1).trim().toLowerCase();
}

export function isBlockedEmailDomain(email: string): boolean {
  const d = emailDomain(email);
  return d !== '' && BLOCKED_EMAIL_DOMAINS.has(d);
}

export class BlockedEmailDomainError extends Error {
  readonly domain: string;
  constructor(domain: string) {
    super(
      `${domain} is a public or disposable email provider. ` +
      `Please sign up with a company email.`,
    );
    this.name = 'BlockedEmailDomainError';
    this.domain = domain;
  }
}
